import React from "react";
import RuleStatusToggle from "../../shared/RuleStatusToggle";
import _ from "lodash";
import SafeImage from "../../SafeImage";
import { ChakraFAIcon } from "@/components/ui/Icon";

// if isClassroomRule is true, then userId and userDisplayText are ignored
type NativeAppControlPolicyProps = {
	isClassroomRule: boolean;
	userDisplayText?: string;
	appName: string;
	appFavicon: string;
	action: string;
	handleModify: () => void;
	handleChangeAction: (action: string) => void;
};

const NativeAppControlPolicy: React.FC<NativeAppControlPolicyProps> = (props: NativeAppControlPolicyProps) => {
	const renderStatus = () => {
		return (
			<RuleStatusToggle
				type={convertActionToType(props.action)}
				onChange={(type: string) => props.handleChangeAction(convertTypeToAction(type))}
			/>
		);
	};

	const getUser = () => {
		if (props.isClassroomRule) {
			return "all users";
		} else {
			return props.userDisplayText;
		}
	};

	const renderWebsiteIcon = () => {
		if (!_.isEmpty(props.appFavicon)) {
			return <SafeImage width={20} height={20} styleClassName="PolicyDrawer_ruleFavicon" src={props.appFavicon} />; //@todo props.appFavicon is undefined in the edit class rule modal. No proper favicon is displayed.
		}

		return <SafeImage width={20} height={20} styleClassName="PolicyDrawer_ruleFavicon" src="/static/images/Icon_Folder.svg" />;
	};

	const user = getUser();
	return (
		<>
			<div className="PolicyDrawer_itemColumn">
				<span className="PolicyDrawer_appIcon">{renderWebsiteIcon()}</span>
				<span className="PolicyDrawer_appText" title={props.appName}>
					{props.appName}
				</span>
			</div>
			<div className="PolicyDrawer_itemColumn PolicyDrawer_text" title={user}>
				{user}
			</div>
			<div className="PolicyDrawer_itemColumn PolicyDrawer_itemActions">
				<span>{renderStatus()}</span>
				<span onClick={props.handleModify}>
					<ChakraFAIcon icon="fa-pencil" variant="solid" className="PolicyDrawer_editRuleIcon" />
				</span>
			</div>
		</>
	);
};

function convertActionToType(action: string) {
	switch (action) {
		case "block":
			return "blocked";
		case "allow":
			return "allowed";
		default:
			throw new Error("unexpected app control rule action: " + action);
	}
}

function convertTypeToAction(type: string) {
	switch (type) {
		case "blocked":
			return "block";
		case "allowed":
			return "allow";
		default:
			throw new Error("unexpected app control rule type: " + type);
	}
}

export default NativeAppControlPolicy;
